import React from 'react'
import { CloseIcon } from '../../../assets/icons/Svg';

interface AvailableProductModalHeaderProps {
    productName: string;
    onClose: () => void;
}

export default function AvailableProductModalHeader({ onClose, productName }: AvailableProductModalHeaderProps) {
    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                    {productName}
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={onClose}
                >
                    <CloseIcon/>
                </button>
            </div>
        </div>
    )
}
